import format from 'date-fns/format';
import addDays from 'date-fns/add_days';
import startOfToday from 'date-fns/start_of_today';
var CookieHelper = /** @class */ (function () {
    function CookieHelper() {
    }
    CookieHelper.checkAndSetCookies = function () {
        this.setShopRefCookie();
        this.setAudiencesCookie();
        this.setLiveUpdatesCookie();
    };
    CookieHelper.setLiveUpdatesCookie = function () {
        try {
            var PARAMETER_NAME = 'liveUpdates';
            var url = new URL(window.location.href);
            if (url.searchParams.get(PARAMETER_NAME)) {
                // @ts-ignore
                //const cookies = new URLSearchParams(document.cookie.replaceAll('&', '%26').replaceAll('; ', '&'));
                var liveUpdatesValue = url.searchParams.get(PARAMETER_NAME);
                var topDomain = window.location.hostname.split('.').slice(-2).join('.');
                if (liveUpdatesValue === 'true' || liveUpdatesValue === '1') {
                    liveUpdatesValue = 'true';
                }
                else {
                    liveUpdatesValue = 'false';
                }
                document.cookie = this.LIVE_UPDATES_COOKIE_NAME + '=' + liveUpdatesValue + '; domain=' + topDomain + '; path=/; max-age=86400; secure=true; SameSite=Lax';
                if (history.replaceState) {
                    url.searchParams.delete(PARAMETER_NAME);
                    window.history.replaceState('', '', url.href);
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    CookieHelper.setShopRefCookie = function () {
        try {
            var PARAMETER_NAME = 'shopRef';
            var url = new URL(window.location.href);
            if (url.searchParams.get(PARAMETER_NAME)) {
                var COOKIE_NAME = 'shopRef';
                // @ts-ignore
                var cookies = new URLSearchParams(document.cookie.replaceAll('&', '%26').replaceAll('; ', '&'));
                var shopRefValue = null;
                if (!cookies.get(COOKIE_NAME)) {
                    shopRefValue = url.searchParams.get(PARAMETER_NAME);
                }
                else {
                    var existingShopRefValue = cookies.get(COOKIE_NAME);
                    shopRefValue = url.searchParams.get(PARAMETER_NAME);
                    //@ts-ignore
                    // Avoid duplicate shopRef entries
                    if (existingShopRefValue && !existingShopRefValue.includes(shopRefValue)) {
                        shopRefValue = existingShopRefValue + ',' + shopRefValue;
                    }
                }
                var topDomain = window.location.hostname.split('.').slice(-2).join('.');
                document.cookie = COOKIE_NAME + '=' + shopRefValue + '; domain=' + topDomain + '; path=/; max-age=86400; secure=true; SameSite=Lax';
                if (history.replaceState) {
                    url.searchParams.delete(PARAMETER_NAME);
                    window.history.replaceState('', '', url.href);
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    CookieHelper.setAudiencesCookie = function () {
        try {
            var url = new URL(window.location.href);
            var utmMedium = url.searchParams.get(CookieHelper.PARAMETER_UTM_MEDIUM);
            var utmSource = url.searchParams.get(CookieHelper.PARAMETER_UTM_SOURCE);
            if (utmMedium && utmSource) {
                // @ts-ignore
                var cookies = new URLSearchParams(document.cookie.replaceAll('&', '%26').replaceAll('; ', '&'));
                CookieHelper.updateAudienceCookie(utmMedium, utmSource);
            }
            CookieHelper.clearExpiredValuesFromAudienceCookie();
        }
        catch (error) {
            console.error(error);
        }
    };
    CookieHelper.updateAudienceCookie = function (utmMedium, utmSource) {
        var audiences = CookieHelper.getAudiencesListFromCookies();
        var updatedAudiences = [];
        if (audiences && utmMedium && utmSource) {
            var expiryDate = format(addDays(startOfToday(), 60), 'YYYY-MM-DD');
            var newAudience = utmMedium + ':' + utmSource;
            var newAudienceWithExpiryDate = newAudience + ';' + expiryDate;
            // Filter audience from audience cookie list when exists already
            for (var _i = 0, audiences_1 = audiences; _i < audiences_1.length; _i++) {
                var audienceWithExpiryDate = audiences_1[_i];
                if (audienceWithExpiryDate && audienceWithExpiryDate.includes(';')) {
                    var audience = audienceWithExpiryDate.split(';')[0];
                    if (audience !== newAudience) {
                        updatedAudiences.push(audienceWithExpiryDate);
                    }
                }
            }
            updatedAudiences.push(newAudienceWithExpiryDate);
        }
        CookieHelper.saveAudiencesToCookies(updatedAudiences);
    };
    CookieHelper.clearExpiredValuesFromAudienceCookie = function () {
        var audiences = CookieHelper.getAudiencesListFromCookies();
        var clearedAudiences = [];
        if (audiences) {
            for (var _i = 0, audiences_2 = audiences; _i < audiences_2.length; _i++) {
                var audience = audiences_2[_i];
                if (audience && audience.includes(';')) {
                    var expiryDateString = audience.split(';')[1];
                    try {
                        var expiryDate = new Date(expiryDateString);
                        if (expiryDate > new Date()) {
                            clearedAudiences.push(audience);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }
        }
        CookieHelper.saveAudiencesToCookies(clearedAudiences);
    };
    CookieHelper.getAudiencesListFromCookies = function () {
        // @ts-ignore
        var cookies = new URLSearchParams(document.cookie.replaceAll('&', '%26').replaceAll('; ', '&'));
        var audienceCookie = cookies.get(CookieHelper.AUDIENCES_COOKIE_NAME);
        if (audienceCookie) {
            return decodeURIComponent(audienceCookie).split(',');
        }
        return [];
    };
    CookieHelper.saveAudiencesToCookies = function (audiences) {
        if (audiences) {
            var cookieValue = encodeURIComponent(audiences.join(','));
            var topDomain = window.location.hostname.split('.').slice(-2).join('.');
            document.cookie = CookieHelper.AUDIENCES_COOKIE_NAME + '=' + cookieValue + '; domain=' + topDomain + '; path=/; max-age=31557600; secure=true; SameSite=Lax';
        }
    };
    CookieHelper.isLiveUpdatesEnabled = function () {
        // @ts-ignore
        var cookies = new URLSearchParams(document.cookie.replaceAll('&', '%26').replaceAll('; ', '&'));
        var liveUpdatesCookie = cookies.get(CookieHelper.LIVE_UPDATES_COOKIE_NAME);
        if (liveUpdatesCookie === 'false' || liveUpdatesCookie === '0') {
            return false;
        }
        return true;
    };
    CookieHelper.PARAMETER_UTM_MEDIUM = 'utm_medium';
    CookieHelper.PARAMETER_UTM_SOURCE = 'utm_source';
    CookieHelper.AUDIENCES_COOKIE_NAME = 'audiences';
    CookieHelper.LIVE_UPDATES_COOKIE_NAME = 'liveUpdates';
    return CookieHelper;
}());
export { CookieHelper };
export default CookieHelper;
